import styled from '@emotion/styled';
import { TableBody } from 'src/domains/common/components/table/table';
import { TableColor } from 'src/assets/colors';

export const StyledTableBody = styled(TableBody, { label: 'StyledTableBody' })`
    tr:nth-of-type(odd) {
        background-color: ${TableColor.bgPrimary};
    }
    tr:nth-of-type(even) td > div {
        background-color: ${TableColor.bgPrimary};
    }
`;
